import { useMemo } from "react";
import { Route } from "react-router-dom";
import { TabLayout } from "../../ui_elements";

export const AdmissionListRouter = ({
	component,
	path,
	exact,
	purpose,
	title,
	user,
	...rest
}) => {
	const Component = component;
	const paths = useMemo(
		() => [
			{
				title: "View & Upload Admission List",
				path: "/admission_list/view",
				disabled: false
			},
			{
				title: "Search Admission List",
				path: "/admission_list/search",
				disabled: false
			},
			{
				title: "Admission Ranking",
				path: "/admission_list/ranking",
				disabled: false
			}
		],
		[]
	);
	return (
		<Route
			exact={exact}
			path={path}
			{...rest}
			render={(props) => {
				return (
					<TabLayout title={title} paths={paths}>
						<Component {...rest} {...props} />
					</TabLayout>
				);
			}}
		/>
	);
};
